import React, { PropsWithChildren } from "react";
import Tooltip from "../Tooltip/Tooltip";
import Info from "../../assets/Info.svg";
import CircleCheck from "../../assets/CheckCircle.svg";

const Content: React.FC<
  PropsWithChildren<{
    title: string | React.ReactElement;
    tooltipContent?: {
      title: string;
      description: string | React.ReactElement;
    };
    description?: string | React.ReactElement;
    showSuccessIcon?: boolean;
    icon?: React.ReactElement;
  }>
> = ({
  title,
  children,
  tooltipContent,
  description,
  showSuccessIcon,
  icon
}) => {
  return (
    <div className="flex flex-col items-center max-w-4xl mx-auto text-center py-8 px-6 gap-2">
      {showSuccessIcon && (
        <CircleCheck className="text-coinage-teal" width="40" />
      )}
      {icon}
      <h1 className="subhead1 mb-2">{title}</h1>
      <p className="body1 text-coinage-body text-center">
        <span>{description}</span>
        {tooltipContent && (
          <Tooltip
            buttonClassName="ml-2 text-coinage-black"
            tooltipLabel={<Info width="20" />}
            tooltipTitle={tooltipContent.title}
            tooltipContent={tooltipContent.description}
          />
        )}
      </p>
      {children}
    </div>
  );
};

export default Content;
